import React from 'react'
import moment from 'moment'
import { IconButton } from '@mui/material'
import Message from '@mui/icons-material/Message'
import type { SingleDayFeelingMeterReport } from './feelingReportTypes'
import css from './Feelings.css'
import RestrictedView from '../../auth/RestrictedView'
type Props = {
  data: SingleDayFeelingMeterReport
  onOpenFeedback: (...args: Array<any>) => any
}

const DayRow = ({ data, onOpenFeedback }: Props) => {
  const { dayAverage, feedbackNumber, date, employeesNumber, notesNumber, feelingMetersNumber } = data
  return (
    <tr className={css.dayRow}>
      <td>{moment(date).format('D.M - dd')}</td>
      <td>{dayAverage}</td>
      <td>{`${feelingMetersNumber}/${employeesNumber}`}</td>
      <td>{feedbackNumber}</td>
      <RestrictedView requiredPermission='view_feedback'>
        <td className={css.feedbackColumn}>
          <IconButton onClick={onOpenFeedback} disabled={notesNumber <= 0}>
            <Message fontSize='small' />
          </IconButton>
        </td>
      </RestrictedView>
    </tr>
  )
}

export default DayRow
